import axios, {
  InternalAxiosRequestConfig,
  AxiosError,
  AxiosResponse,
} from "axios";
import config from "../config/environment";
import { decodeTokenService } from "./decodeTokenService";

// const apiUrl = config.apiUrl;
const apiUrlWebsite = config.apiUrlWebsite;
const apiUrlConversationalEngine = config.apiUrlConversationalEngine;
const apiUrlTemplates = config.apiUrlTemplates;
const apiUrlN8N = config.apiUrlN8N;
const apiUrlAnalytics = config.apiUrlAnalytics;
const apiUrlAnalyticsExperiments = config.apiUrlAnalyticsExperiments;
const servicesFluxiUrl = config.servicesFluxiUrl;

// export const axiosInstance = axios.create({
//   baseURL: apiUrl,
//   timeout: 180000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

export const axiosInstanceN8N = axios.create({
  baseURL: apiUrlN8N,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceN8NToken = axios.create({
  baseURL: apiUrlN8N,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceConversationalEngine = axios.create({
  baseURL: apiUrlConversationalEngine,
  timeout: 180000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceTemplates = axios.create({
  baseURL: apiUrlTemplates,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstancePrivateServicesFluxiUrl = axios.create({
  baseURL: servicesFluxiUrl,
  timeout: 240000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceWebsite = axios.create({
  baseURL: apiUrlWebsite,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceWebsitePublic = axios.create({
  baseURL: apiUrlWebsite,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceAnalytics = axios.create({
  baseURL: apiUrlAnalytics,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceAnalyticsExperiments = axios.create({
  baseURL: apiUrlAnalyticsExperiments,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceGeoLocation = axios.create({
  baseURL: config.geoLocationApiUrl,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosInstanceWhatsAppConfirmation = axios.create({
  baseURL: config.apiUrlWhatsAppConfirmation,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstanceWhatsAppConfirmation.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = decodeTokenService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     const token = decodeTokenService.getToken();
//     if (token) {
//       config.headers = config.headers || {};
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error: AxiosError) => {
//     return Promise.reject(error);
//   }
// );

axiosInstanceN8NToken.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = decodeTokenService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },  
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axiosInstanceConversationalEngine.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = decodeTokenService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axiosInstanceWebsite.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = decodeTokenService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axiosInstanceWebsite.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.error("Your session has expired, please log in again.");
    }
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (response: AxiosResponse) => response,
//   (error: AxiosError) => {
//     if (error.response?.status === 401) {
//       console.error("No autorizado, redirigiendo a inicio de sesión.");
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

axiosInstancePrivateServicesFluxiUrl.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = decodeTokenService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);